<template>
  <div class="wcdiv wcpage" style="width: 595.3pt; height: 841.9pt">
    <div
      class="wcdiv"
      style="
        left: 28.35pt;
        top: 818.9pt;
        clip: rect(0pt, 566.95pt, 24pt, -28.35pt);
      "
    >
      <span
        class="wcspan wctext004"
        style="
          font-size: 10pt;
          left: 266.8pt;
          top: 0.42pt;
          line-height: 11.07pt;
        "
        >6</span
      >
    </div>
    <div class="wcdiv" style="left: 28.35pt; top: 28.35pt">
      <div
        class="wcdiv"
        style="
          left: -0.05pt;
          top: -0.05pt;
          width: 63.9pt;
          height: 20.7pt;
          background-color: #d8d8d8;
          border: solid 0.1pt #d8d8d8;
        "
      >
        &nbsp;
      </div>
      <div
        class="wcdiv"
        style="
          left: 63.95pt;
          top: -0.05pt;
          width: 15.9pt;
          height: 20.7pt;
          background-color: #d8d8d8;
          border: solid 0.1pt #d8d8d8;
        "
      >
        &nbsp;
      </div>
      <div
        class="wcdiv"
        style="
          left: 79.95pt;
          top: -0.05pt;
          width: 159.9pt;
          height: 20.7pt;
          background-color: #d8d8d8;
          border: solid 0.1pt #d8d8d8;
        "
      >
        &nbsp;
      </div>
      <span
        class="wcspan wctext002"
        style="font-size: 16pt; left: 0pt; top: 1.61pt; line-height: 19.19pt"
        >第九部分：極早期失智症篩檢量表</span
      >
      <div class="wcdiv" style="top: 20.8pt">
        <span
          class="wcspan wctext002"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >注意：&rdquo;是，有改變&rdquo;代表你認為過去的幾年中因為認知功能(思考和記憶)問題而導致改變。</span
        >
      </div>
      <div class="wcdiv" style="top: 37.69pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >1.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 18pt; top: 1.31pt; line-height: 15.59pt"
          >判斷力的困難：例如落入圈套或騙局，財務上不好的決定，買了對受禮者不合宜的禮物。</span
        >
      </div>
      <div class="wcdiv" style="left: 18pt; top: 54.59pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{
            ifq(
              "1.判斷力的困難：例如落入圈套或騙局，財務上不好的決定，買了對受禮者不合宜的禮物。",
              "0.是，有改變",
              "■",
              "□",
            )
          }}0.是，有改變</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 91pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 110.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq(
              "1.判斷力的困難：例如落入圈套或騙局，財務上不好的決定，買了對受禮者不合宜的禮物。",
              "1.不是，沒有改變",
              "■",
              "□",
            )
          }}1.不是，沒有改變</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 227.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 247pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq(
              "1.判斷力的困難：例如落入圈套或騙局，財務上不好的決定，買了對受禮者不合宜的禮物。",
              "2.不知道",
              "■",
              "□",
            )
          }}2.不知道</span
        >
      </div>
      <div class="wcdiv" style="top: 71.49pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >2.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 18pt; top: 1.31pt; line-height: 15.59pt"
          >對活動或嗜好的興趣降低。</span
        >
      </div>
      <div class="wcdiv" style="left: 18pt; top: 88.39pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{
            ifq("2.對活動或嗜好的興趣降低。", "0.是，有改變", "■", "□")
          }}0.是，有改變</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 91pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 110.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("2.對活動或嗜好的興趣降低。", "1.不是，沒有改變", "■", "□")
          }}1.不是，沒有改變</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 227.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 247pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("2.對活動或嗜好的興趣降低。", "2.不知道", "■", "□")
          }}2.不知道</span
        >
      </div>
      <div class="wcdiv" style="top: 105.28pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >3.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 18pt; top: 1.31pt; line-height: 15.59pt"
          >重複相同的問題、故事和陳述。</span
        >
      </div>
      <div class="wcdiv" style="left: 18pt; top: 122.18pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{
            ifq("3.重複相同的問題、故事和陳述。", "0.是，有改變", "■", "□")
          }}0.是，有改變</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 91pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 110.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("3.重複相同的問題、故事和陳述。", "1.不是，沒有改變", "■", "□")
          }}1.不是，沒有改變</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 227.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 247pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("3.重複相同的問題、故事和陳述。", "2.不知道", "■", "□")
          }}2.不知道</span
        >
      </div>
      <div class="wcdiv" style="top: 139.08pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >4.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 18pt; top: 1.31pt; line-height: 15.59pt"
          >在學習如何使用工具、設備和小器具上有困難。例如：電視、音響、冷氣機、洗衣機、熱水</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 18pt; top: 18.2pt; line-height: 15.59pt"
          >爐(器)、微波爐、遙控器。</span
        >
      </div>
      <div class="wcdiv" style="left: 18pt; top: 172.87pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{
            ifq(
              "4.在學習如何使用工具、設備和小器具上有困難。例如：電視、音響、冷氣機、洗衣機、熱水爐(器)、微波爐、遙控器。",
              "0.是，有改變",
              "■",
              "□",
            )
          }}0.是，有改變</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 91pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 110.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq(
              "4.在學習如何使用工具、設備和小器具上有困難。例如：電視、音響、冷氣機、洗衣機、熱水爐(器)、微波爐、遙控器。",
              "1.不是，沒有改變",
              "■",
              "□",
            )
          }}1.不是，沒有改變</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 227.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 247pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq(
              "4.在學習如何使用工具、設備和小器具上有困難。例如：電視、音響、冷氣機、洗衣機、熱水爐(器)、微波爐、遙控器。",
              "2.不知道",
              "■",
              "□",
            )
          }}2.不知道</span
        >
      </div>
      <div class="wcdiv" style="top: 189.77pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >5.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 18pt; top: 1.31pt; line-height: 15.59pt"
          >忘記正確的月份和年份。</span
        >
      </div>
      <div class="wcdiv" style="left: 18pt; top: 206.66pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{
            ifq("5.忘記正確的月份和年份。", "0.是，有改變", "■", "□")
          }}0.是，有改變</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 91pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 110.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("5.忘記正確的月份和年份。", "1.不是，沒有改變", "■", "□")
          }}1.不是，沒有改變</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 227.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 247pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("5.忘記正確的月份和年份。", "2.不知道", "■", "□")
          }}2.不知道</span
        >
      </div>
      <div class="wcdiv" style="top: 223.56pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >6.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 18pt; top: 1.31pt; line-height: 15.59pt"
          >處理複雜的財務上有困難。例如：個人或家庭的收支平衡、所得稅、繳費單。</span
        >
      </div>
      <div class="wcdiv" style="left: 18pt; top: 240.46pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{
            ifq(
              "6.處理複雜的財務上有困難。例如：個人或家庭的收支平衡、所得稅、繳費單。",
              "0.是，有改變",
              "■",
              "□",
            )
          }}0.是，有改變</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 91pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 110.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq(
              "6.處理複雜的財務上有困難。例如：個人或家庭的收支平衡、所得稅、繳費單。",
              "1.不是，沒有改變",
              "■",
              "□",
            )
          }}1.不是，沒有改變</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 227.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 247pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq(
              "6.處理複雜的財務上有困難。例如：個人或家庭的收支平衡、所得稅、繳費單。",
              "2.不知道",
              "■",
              "□",
            )
          }}2.不知道</span
        >
      </div>
      <div class="wcdiv" style="top: 257.36pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >7.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 18pt; top: 1.31pt; line-height: 15.59pt"
          >記住約會的時間有困難。</span
        >
      </div>
      <div class="wcdiv" style="left: 18pt; top: 274.25pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{
            ifq("7.記住約會的時間有困難。", "0.是，有改變", "■", "□")
          }}0.是，有改變</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 91pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 110.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("7.記住約會的時間有困難。", "1.不是，沒有改變", "■", "□")
          }}1.不是，沒有改變</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 227.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 247pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("7.記住約會的時間有困難。", "2.不知道", "■", "□")
          }}2.不知道</span
        >
      </div>
      <div class="wcdiv" style="top: 291.15pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >8.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 18pt; top: 1.31pt; line-height: 15.59pt"
          >有持續的思考和記憶方面的問題。</span
        >
      </div>
      <div class="wcdiv" style="top: 308.05pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 19.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("8.有持續的思考和記憶方面的問題。", "0.是，有改變", "■", "□")
          }}0.是，有改變</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 110.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 130pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq(
              "8.有持續的思考和記憶方面的問題。",
              "1.不是，沒有改變",
              "■",
              "□",
            )
          }}1.不是，沒有改變</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 247pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 266.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("8.有持續的思考和記憶方面的問題。", "2.不知道", "■", "□")
          }}2.不知道</span
        >
      </div>
      <div class="wcdiv" style="top: 345.74pt">
        <div
          class="wcdiv"
          style="
            left: -0.05pt;
            top: -0.05pt;
            width: 79.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 79.95pt;
            top: -0.05pt;
            width: 15.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 95.95pt;
            top: -0.05pt;
            width: 207.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 303.95pt;
            top: -0.05pt;
            width: 15.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <span
          class="wcspan wctext002"
          style="font-size: 16pt; left: 0pt; top: 1.61pt; line-height: 19.19pt"
          >※意見信箱【以下由滿意度之工作人員填寫】</span
        >
      </div>
      <div class="wcdiv" style="top: 366.54pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.71pt;
            line-height: 14.99pt;
          "
          >1.</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 12.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >請問您怎麼知道今天這項活動的？</span
        >
      </div>
      <div class="wcdiv" style="left: 13pt; top: 383.43pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{
            ifq("1.請問您怎麼知道今天這項活動的？", "1.衛生所通知", "■", "□")
          }}1.衛生所通知</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 91pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 110.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("1.請問您怎麼知道今天這項活動的？", "2.里長通知", "■", "□")
          }}2.里長通知</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 188.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 208pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("1.請問您怎麼知道今天這項活動的？", "3.親朋好友告知", "■", "□")
          }}3.親朋好友告知</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 312pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 331.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("1.請問您怎麼知道今天這項活動的？", "4.看報紙", "■", "□")
          }}4.看報紙</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 396.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 416pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("1.請問您怎麼知道今天這項活動的？", "5.路過順便", "■", "□")
          }}5.路過順便</span
        >
      </div>
      <div class="wcdiv" style="left: 13pt; top: 400.33pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{
            ifq("1.請問您怎麼知道今天這項活動的？", "6.衛生局網頁", "■", "□")
          }}6.衛生局網頁</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 91pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 110.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq(
              "1.請問您怎麼知道今天這項活動的？",
              "7.FB、簡訊或LINE",
              "■",
              "□",
            )
          }}7.FB、簡訊或LINE</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 227.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 247pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("1.請問您怎麼知道今天這項活動的？", "8.其他，請說明", "■", "□")
          }}8.其他，請說明</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 351pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 370pt; top: -2pt"
          >&nbsp;{{
            ifqOther("1.請問您怎麼知道今天這項活動的？", "8.其他，請說明")
          }}</span
        >
        <div
          class="wcdiv"
          style="
            left: 351pt;
            top: 14.01pt;
            width: 162.5pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="top: 417.23pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >2.您目前的教育程度是：</span
        >
      </div>
      <div class="wcdiv" style="left: 12.93pt; top: 434.13pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{
            ifq("2.您目前的教育程度是：", "1.研究所或以上", "■", "□")
          }}1.研究所或以上
          {{ ifq("2.您目前的教育程度是：", "2.大學(專)", "■", "□") }}2.大學(專)
          {{ ifq("2.您目前的教育程度是：", "3.高中(職)", "■", "□") }}3.高中(職)
          {{ ifq("2.您目前的教育程度是：", "4.國(初)中", "■", "□") }}4.國(初)中
        </span>
      </div>
      <div class="wcdiv" style="left: 12.93pt; top: 451.02pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{ ifq("2.您目前的教育程度是：", "5.小學", "■", "□") }}5.小學</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 52pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 110.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("2.您目前的教育程度是：", "6.識字", "■", "□") }}6.識字</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 162.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 195pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("2.您目前的教育程度是：", "7.不識字", "■", "□")
          }}7.不識字</span
        >
      </div>
      <div class="wcdiv" style="top: 467.92pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >3.您目前是否持有身心障礙手冊？
          {{
            ifq("3.您目前是否持有身心障礙手冊？", "0.是", "■", "□")
          }}0.是</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 240.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 253.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("3.您目前是否持有身心障礙手冊？", "1.否", "■", "□")
          }}1.否</span
        >
      </div>
      <div class="wcdiv" style="top: 484.82pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >4.您是否有具有原住民身份？
          {{
            ifq(
              [
                "4.您是否有具有原住民身份？",
                "4.您是否有具有原住民身份?",
                "4.您是否有具有原住民身分？",
                "4.您是否有具有原住民身分?",
              ],
              "0.是",
              "■",
              "□"
            )
          }}0.是</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 214.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 227.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq(
              [
                "4.您是否有具有原住民身份？",
                "4.您是否有具有原住民身份?",
                "4.您是否有具有原住民身分？",
                "4.您是否有具有原住民身分?",
              ],
              "1.否",
              "■",
              "□"
            )
          }}1.否</span
        >
      </div>
      <div class="wcdiv" style="top: 501.71pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >5.您目前的經濟狀況？
          {{
            ifq("5.您目前的經濟狀況？", "0.足夠應付", "■", "□")
          }}0.足夠應付</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 214.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 227.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("5.您目前的經濟狀況？", "1.剛好打平", "■", "□")
          }}1.剛好打平</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 305.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 318.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("5.您目前的經濟狀況？", "2.稍嫌不足", "■", "□")
          }}2.稍嫌不足</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 396.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 409.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("5.您目前的經濟狀況？", "3.較為困難", "■", "□")
          }}3.較為困難</span
        >
      </div>
      <div class="wcdiv" style="top: 518.61pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >6.請問您目前居住狀況：{{
            ifq("6.請問您目前居住狀況：", "1.獨居", "■", "□")
          }}1.獨居</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 195pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 234pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("6.請問您目前居住狀況：", "2.與家人同住", "■", "□")
          }}2.與家人同住
          {{ ifq("6.請問您目前居住狀況：", "3.其他", "■", "□") }}3.其他</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 390pt; top: -2pt"
          >&nbsp;{{ ifqOther("1.請問您目前居住狀況：", "3.其他") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 383.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <div
          class="wcdiv"
          style="
            left: 383.5pt;
            top: 14.01pt;
            width: 78pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="top: 535.51pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >7.婚姻狀況：{{ ifq("7.婚姻狀況：", "1.未婚", "■", "□") }}1.未婚</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 130pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 143pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("7.婚姻狀況：", "2.已婚", "■", "□") }}2.已婚</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 195pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 234pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("7.婚姻狀況：", "3.離婚", "■", "□") }}3.離婚</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 286pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 331.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("7.婚姻狀況：", "4.喪偶", "■", "□") }}4.喪偶</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 383.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 396.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("7.婚姻狀況：", "5.其他", "■", "□") }}5.其他</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 448.5pt; top: -2pt"
          >&nbsp;{{ ifqOther("7.婚姻狀況：", "5.其他") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 448.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <div
          class="wcdiv"
          style="
            left: 448.5pt;
            top: 14.01pt;
            width: 78pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="top: 552.4pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >8.睡眠狀況：{{ ifq("8.睡眠狀況：", "1.良好", "■", "□") }}1.良好</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 130pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 143pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("8.睡眠狀況：", "2.入睡困難", "■", "□") }}2.入睡困難</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 221pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 234pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("8.睡眠狀況：", "3.睡眠中斷", "■", "□") }}3.睡眠中斷</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 312pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 331.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("8.睡眠狀況：", "4.早醒", "■", "□") }}4.早醒</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 383.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 396.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("8.睡眠狀況：", "5.其他", "■", "□") }}5.其他</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 448.5pt; top: -2pt"
          >&nbsp;{{ ifqOther("8.睡眠狀況：", "5.其他") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 448.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <div
          class="wcdiv"
          style="
            left: 448.5pt;
            top: 14.01pt;
            width: 90.1pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="top: 569.3pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >9.一年內有無重大事件發生：</span
        >
      </div>
      <div class="wcdiv" style="left: 21.86pt; top: 586.2pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{ ifq("9.一年內有無重大事件發生：", "1.無", "■", "□") }}1.無</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 39pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 52pt; top: 1.31pt; line-height: 15.59pt"
          >{{ ifq("9.一年內有無重大事件發生：", "2.有", "■", "□") }}2.有，{{
            ifq("9.一年內有無重大事件發生：", "a.親友死亡", "■", "□")
          }}a.親友死亡</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 182pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 195pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("9.一年內有無重大事件發生：", "b.身體疾病", "■", "□")
          }}b.身體疾病</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 273pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 286pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("9.一年內有無重大事件發生：", "c.被騙錢", "■", "□")
          }}c.被騙錢</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 351pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 364pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("9.一年內有無重大事件發生：", "d.其他", "■", "□")
          }}d.其他</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 430.5pt; top: -2pt"
          >&nbsp;{{ ifqOther("9.一年內有無重大事件發生：", "d.其他") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 416pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <div
          class="wcdiv"
          style="
            left: 416pt;
            top: 14.01pt;
            width: 100.74pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="top: 603.1pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >10.您對於今天的服務感到滿意嗎？</span
        >
      </div>
      <div class="wcdiv" style="left: 21.86pt; top: 619.99pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{
            ifq("您對於今天的服務感到滿意嗎？", "1.非常滿意", "■", "□")
          }}1.非常滿意
          {{ ifq("您對於今天的服務感到滿意嗎？", "2.滿意", "■", "□") }}2.滿意
          {{ ifq("您對於今天的服務感到滿意嗎？", "3.普通", "■", "□") }}3.普通
          {{
            ifq("您對於今天的服務感到滿意嗎？", "4.不滿意", "■", "□")
          }}4.不滿意
          {{
            ifq("您對於今天的服務感到滿意嗎？", "5.非常不滿意", "■", "□")
          }}5.非常不滿意</span
        >
      </div>
      <div class="wcdiv" style="left: 22.1pt; top: 636.89pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >滿意或不滿意的原因？</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 145pt; top: -2pt"
          >&nbsp;{{ ift("滿意或不滿意的原因？") }}</span
        >

        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 130pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <div
          class="wcdiv"
          style="
            left: 130pt;
            top: 14.01pt;
            width: 377pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="top: 653.79pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >11.如果以後我們有類似的檢查活動，您會再次參加嗎？</span
        >
      </div>
      <div class="wcdiv" style="left: 21.86pt; top: 670.68pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{
            ifq(
              "11.如果以後我們有類似的檢查活動，您會再次參加嗎？",
              "1.會",
              "■",
              "□",
            )
          }}1.會
          {{
            ifq(
              "11.如果以後我們有類似的檢查活動，您會再次參加嗎？",
              "2.不會",
              "■",
              "□",
            )
          }}2.不會；為什麼會/不會再次參加？</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 272pt; top: -2pt"
          >&nbsp;{{ ift("為什麼會/不會再次參加？") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 260pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <div
          class="wcdiv"
          style="
            left: 260pt;
            top: 14.01pt;
            width: 256.74pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="top: 687.58pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >12.您會介紹親朋好友來參加我們的活動嗎？</span
        >
      </div>
      <div class="wcdiv" style="left: 21.86pt; top: 704.48pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >{{
            ifq("12.您會介紹親朋好友來參加我們的活動嗎？", "1.會", "■", "□")
          }}1.會
          {{
            ifq("12.您會介紹親朋好友來參加我們的活動嗎？", "2.不會", "■", "□")
          }}2.不會；為什麼會/不會再次參加？</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 272pt; top: -2pt"
          >&nbsp;{{ ift("為什麼會/不會再次參加？") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 260pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <div
          class="wcdiv"
          style="
            left: 260pt;
            top: 14.01pt;
            width: 256.74pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="top: 721.37pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >13.您認為此次活動有需要改進的地方嗎?</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 234pt; top: -2pt"
          >&nbsp;{{ ift("您認為此次活動有需要改進的地方嗎?") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 234pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <div
          class="wcdiv"
          style="
            left: 234pt;
            top: 14.01pt;
            width: 292.5pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
    </div>
    <div class="wcdiv" style="left: 371.95pt; top: 286.5pt">
      <div
        class="wcdiv"
        style="
          left: -0.38pt;
          top: -0.38pt;
          width: 259px;
          height: 93px;
          font-size: 0pt;
        "
      >
        &nbsp;
      </div>
      <div class="wcdiv" style="clip: rect(3.95pt, 193.05pt, 66.25pt, 0.35pt)">
        <div class="wcdiv" style="left: 7.55pt; top: 3.95pt">
          <span
            class="wcspan wctext001"
            style="
              font-size: 10pt;
              left: 0pt;
              top: 1.01pt;
              line-height: 11.99pt;
            "
            >當有</span
          >
          <span
            class="wcspan wctext001"
            style="
              font-size: 10pt;
              left: 22.5pt;
              top: 1.01pt;
              line-height: 11.99pt;
            "
            >2</span
          >
          <span
            class="wcspan wctext001"
            style="
              font-size: 10pt;
              left: 30pt;
              top: 1.01pt;
              line-height: 11.99pt;
            "
            >題以上為</span
          >
          <span
            class="wcspan wctext001"
            style="
              font-size: 10pt;
              left: 69.58pt;
              top: 1.01pt;
              line-height: 11.99pt;
            "
            >「是</span
          >
          <span
            class="wcspan wctext001"
            style="
              font-size: 10pt;
              left: 89.36pt;
              top: 1.01pt;
              line-height: 11.99pt;
            "
            >，</span
          >
          <span
            class="wcspan wctext001"
            style="
              font-size: 10pt;
              left: 99.15pt;
              top: 1.01pt;
              line-height: 11.99pt;
            "
            >有改變」</span
          >
          <span
            class="wcspan wctext001"
            style="
              font-size: 10pt;
              left: 138.73pt;
              top: 1.01pt;
              line-height: 11.99pt;
            "
            >時</span
          >
          <span
            class="wcspan wctext001"
            style="
              font-size: 10pt;
              left: 148.51pt;
              top: 1.01pt;
              line-height: 11.99pt;
            "
            >，</span
          >
          <span
            class="wcspan wctext001"
            style="
              font-size: 10pt;
              left: 158.3pt;
              top: 1.01pt;
              line-height: 11.99pt;
            "
            >建議</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 10pt; left: 0pt; top: 14pt; line-height: 11.99pt"
            >您接受進一步的檢查及診療</span
          >
          <span
            class="wcspan wctext001"
            style="
              font-size: 10pt;
              left: 119.15pt;
              top: 14pt;
              line-height: 11.99pt;
            "
            >，</span
          >
          <span
            class="wcspan wctext001"
            style="
              font-size: 10pt;
              left: 128.3pt;
              top: 14pt;
              line-height: 11.99pt;
            "
            >可洽精神科</span
          >
          <div
            class="wcdiv"
            style="
              left: 148.3pt;
              top: 23.77pt;
              width: 30pt;
              height: 0pt;
              border-top: solid 0.75pt #000000;
            "
          >
            &nbsp;
          </div>
          <span
            class="wcspan wctext001"
            style="font-size: 10pt; left: 0pt; top: 27pt; line-height: 11.99pt"
            >或神經內科。</span
          >
          <div
            class="wcdiv"
            style="
              left: 10pt;
              top: 36.77pt;
              width: 40pt;
              height: 0pt;
              border-top: solid 0.75pt #000000;
            "
          >
            &nbsp;
          </div>
          <div class="wcdiv" style="top: 38.99pt">
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >(</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 5.34pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >出</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 15.68pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >處</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 26.02pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >：</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 36.36pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >楊</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 46.71pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >淵</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 57.05pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >韓</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 67.39pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
            >
            </span>
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 72.73pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >劉</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 83.07pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >景</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 93.41pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >寬</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 103.75pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
            >
            </span>
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 109.09pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >2009</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 131.93pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >年
            </span>
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 147.62pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >世</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 157.96pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >界</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 168.3pt;
                top: 1.01pt;
                line-height: 11.99pt;
              "
              >阿</span
            >
            <span
              class="wcspan wctext001"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 14pt;
                line-height: 11.99pt;
              "
              >茲海默氏失智症大會)</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MixinBigQuiz from "@/mixins/bigQuiz";
import "@/assets/bigQuiz.scss";
export default {
  mixins: [MixinBigQuiz],
};
</script>
